import React from "react";
import { Field, useForm } from "react-final-form";
import { FormGroup, Label, Col } from "reactstrap";

import { InputField, ReactDropzone, required } from "modules/4_final_form/web";
import { FieldArray } from "react-final-form-arrays";
import _ from "lodash";
import { AccordionContent, BlockTitle, Link, List, ListItem } from "framework7-react";

export const InlineAttachmentsFieldAttributes = (props) => {
  const { fieldName, namesUsed } = props;
  const form = useForm();
  const { values } = form.getState();
  const thisField = _.get(values, fieldName);

  return (
    <div>
      <FormGroup row>
        <Label md={3}>Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Label</Label>
        <Col md={9}>
          <Field name={`${fieldName}.label`} component={InputField} validate={required} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col md={12}>
          <FieldArray
            name="attachments_attributes"
            uploadNow
            addProps={{ field_name: thisField.name }}
            filterBy="field_name"
            filterValue={thisField.name || "temp"}
            component={ReactDropzone}
          />
        </Col>
      </FormGroup>
    </div>
  );
};

export const InlineAttachmentsFieldForm = (props) => {
  const { label, name, custom_form } = props;

  const attachments = _.get(custom_form, "attachments_attributes");
  const findAttachments = _.filter(attachments, { field_name: name });

  return (
    <FormGroup row>
      {label && <Label md={2}>{label}</Label>}
      <Col md={10}>
        <ul>
          {_.map(findAttachments, (attachment) => (
            <li>
              <a href={attachment.url} target="_blank">
                {attachment.name}
              </a>
            </li>
          ))}
        </ul>
      </Col>
    </FormGroup>
  );
};

export const MobileInlineAttachmentsFieldForm = (props) => {
  const { label, name, custom_form } = props;

  const attachments = _.get(custom_form, "attachments_attributes");
  const findAttachments = _.filter(attachments, { field_name: name });

  return (
    <List>
      <ListItem title={label} />
      {_.map(findAttachments, (attachment) => (
        <ListItem  key={attachment.id} className="margin-left" link={attachment.url} target="_blank" external>
            {attachment.name}
        </ListItem>
      ))}
    </List>
  );
};
MobileInlineAttachmentsFieldForm.defaultProps = {
  prefixName: "data",
};

